import React from "react";
import freeReports from "../../PicesForPages/FreeReports.jpg";
import FreeReports from "../Form/FreeReports";

function GetInformativeFreeReports() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={freeReports}
          alt="freeReportsImage"
          className="background-video freeReportsImage"
        />
        <div className="purchasetopBox GetInformativeFreeReportsPageTopBox">
          {/* The existing Purchase span */}
          <span>Access Your Free Report</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox freeReportsBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftContent">
              At <span className="logoBoldColor">The Mortgageist</span>, we've
              assembled these free reports to help you become a more
              knowledgeable consumer.
            </span>
          </div>
          <FreeReports />
        </div>
      </div>
    </div>
  );
}

export default GetInformativeFreeReports;
